import { setPayPalPayments } from './setPayPalPayment.js';
import { sendFreeOrderToEventive } from '../order/sendFreeOrderToEventive.js';
import { createAndUpdateOrder } from '../order/createAndUpdateOrder.js';
import sessionStorageModule from '../utils/sessionStorageModule.js';
import { eventPass } from '../helper/EventPass.js';

/**
 * Handle the "Buy Now" button functionality and the order process, including PayPal button rendering.
 * If the total amount is greater than zero, the PayPal buttons are shown for payment processing.
 * If the total amount is zero (due to coupons or other discounts), the order is sent directly to Eventive.
 *
 * @param {string} privatApiKey - The privatApiKey.
 * @param {string} eventBucketId - The eventBucketId.
 */
export function submitBuyNowAndOrderButton(privatApiKey, eventBucketId) {
  const buyNowButton = document.getElementById('by_now_button');

  if (!buyNowButton.dataset.listenerAdded) {
    // Add the event listener with a closure to capture the parameters
    buyNowButton.addEventListener('click', async () => {
      // Ensure that parameters are accessible inside the event listener

      const eventPassPayload = eventPass.get();

      const paypalButtonContainer = document.getElementById('paypal-pay-container');
      const userData = sessionStorageModule.getItem('gd-checkout-data');

      // Call createAndUpdateOrder with the parameters from the function scope
      const order = await createAndUpdateOrder(privatApiKey, eventBucketId, userData, eventPassPayload);
      const totalAmount = order?.total || 0;
      const orderQuantity = order?.total_quantity || 0;

      if (order && order.isProcessed) {
        console.trace('Order already processed.');
        return;
      }

      // Handle PayPal button visibility based on order amount
      if (totalAmount > 0) {
        paypalButtonContainer.classList.remove('hidden');
        try {
          await setPayPalPayments(privatApiKey, eventBucketId);
          order.isProcessed = true;
        } catch (error) {
          console.error('PayPal button render error:', error);
        }
      }
      // Handle free orders if total amount is 0 but quantity is positive
      else if (totalAmount <= 0 && orderQuantity > 0) {
        paypalButtonContainer.classList.add('hidden');
        try {
          await sendFreeOrderToEventive(order);
          order.isProcessed = true;
        } catch (error) {
          console.error('Error sending free order:', error);
        }
      }
      // Handle case where no valid order exists
      else {
        paypalButtonContainer.classList.add('hidden');
      }

    });

    // Mark that the listener has been added to avoid duplicate listeners
    buyNowButton.dataset.listenerAdded = true;
  }
}


